/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CourseUpdateInput = {
    description?: string | null | undefined;
    id: string;
    name?: string | null | undefined;
};
export type CourseEdit_CourseEditMutationVariables = {
    input: CourseUpdateInput;
};
export type CourseEdit_CourseEditMutationResponse = {
    readonly courseUpdate: {
        readonly result: {
            readonly id: string;
            readonly name: string;
            readonly description: string | null;
        } | null;
        readonly successful: boolean;
        readonly messages: ReadonlyArray<{
            readonly code: string;
            readonly field: string | null;
            readonly message: string | null;
        } | null> | null;
    } | null;
};
export type CourseEdit_CourseEditMutation = {
    readonly response: CourseEdit_CourseEditMutationResponse;
    readonly variables: CourseEdit_CourseEditMutationVariables;
};



/*
mutation CourseEdit_CourseEditMutation(
  $input: CourseUpdateInput!
) {
  courseUpdate(input: $input) {
    result {
      id
      name
      description
    }
    successful
    messages {
      code
      field
      message
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CoursePayload",
    "kind": "LinkedField",
    "name": "courseUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Course",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successful",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationMessage",
        "kind": "LinkedField",
        "name": "messages",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CourseEdit_CourseEditMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CourseEdit_CourseEditMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ee8f96936aed8f8781cc4512bce4e815",
    "id": null,
    "metadata": {},
    "name": "CourseEdit_CourseEditMutation",
    "operationKind": "mutation",
    "text": "mutation CourseEdit_CourseEditMutation(\n  $input: CourseUpdateInput!\n) {\n  courseUpdate(input: $input) {\n    result {\n      id\n      name\n      description\n    }\n    successful\n    messages {\n      code\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0131a9aa901eac3b7eb70fccd0fefc95';
export default node;
